var React = require('react');

function Devices (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M127.853 26H33.1768V90.0833H93.0942V56V54H95.0942H127.853V26ZM129.853 54V26V24H127.853H33.1768H31.1768V26V90.0833V92.0833H33.1768H93.0942V97.4584H26H24V99.4584V108V110H26H135.029H137.029V110L146 110V79.5416H138.949V56V54H136.949H129.853ZM136.949 79.5416V56H95.0942V108H122.676V79.5416H136.949ZM93.0942 108V99.4584H26V108L93.0942 108ZM143.997 81.5416H124.679V108H143.997V81.5416Z","fill":"white"}));
}

Devices.defaultProps = {"width":"170","height":"134","viewBox":"0 0 170 134","fill":"none"};

module.exports = Devices;

Devices.default = Devices;
